// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"a87bc254","1605":"29791817"}[chunkId] + ".chunk.css";
};